// extracted by mini-css-extract-plugin
export default {"container":"Alloy_container__fp3Ly","fadeContainer":"Alloy_fadeContainer__5kADR","nextButton":"Alloy_nextButton__ySBK2","formContainer":"Alloy_formContainer__uTd4A"};